/**
 * 职位状态
 */
const ENUM = Object.freeze({
    APPROVAL: '1', // 待审批
    RECRUIT: '2', // 招聘中
    CLOSED: '3', // 已关闭
    REJECT: '4', // 已退回
    ADMIN_APPROVAL: '5', // 平台管理员审批
})

export default Object.freeze(ENUM);

export const getText = (val) => {
    let s = "";
    switch (val) {
        case ENUM.APPROVAL:
            s = "待审批";
            break;
        case ENUM.RECRUIT:
            s = "招聘中";
            break;
        case ENUM.CLOSED:
            s = "已关闭";
            break;
        case ENUM.REJECT:
            s = "已退回";
            break;
        case ENUM.ADMIN_APPROVAL:
            s = "待平台管理员审批";
            break;
    }
    return s;
};